import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
 fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
 toDate: dayjs().endOf("month").format("YYYY-MM-DD"),
 filterModel: null,
 quickFilterText: "",
};

const subconBillingSlice = createSlice({
 name: "subconBilling",
 initialState,
 reducers: {
 setDates: (state, { payload }) => {
 state.fromDate = payload.fromDate;
 state.toDate = payload.toDate;
 },
 setFilterModel: (state, { payload }) => {
 state.filterModel = payload;
 },
 setQuickFilterText: (state, { payload }) => {
 state.quickFilterText = payload;
 },
 resetSubconBillingState: () => initialState,
 },
});

export const {
 setDates,
 setFilterModel,
 setQuickFilterText,
 resetSubconBillingState,
} = subconBillingSlice.actions;

export default subconBillingSlice.reducer;